// test1274
(1274 && 0);
